export default __webpack_public_path__ + "static/media/climaSKurz.b0dfaa0e.jpg";